import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { logos } from '../../constants';
import './pactometro.scss';

export const PactometroCards = ({ seatData, colors }) => {
  const [selectedsId, setSelectedsId] = useState([]);

  const onchange = id => {
    let selecteds = [...selectedsId];
    if (selectedsId.some(select => select === id)) {
      selecteds = selecteds.filter(item => item !== id);
    } else {
      selecteds = [...selecteds, id];
    }

    setSelectedsId(selecteds);
  };

  const selectedData = seatData.filter(item =>
    selectedsId.some(select => select === item.id)
  );

  const tot = seatData.reduce((ac, item) => ac + item.value, 0);
  const { seat } = selectedData.reduce(
    (ac, current) => ({
      seat: ac.seat + current.value,
      votes: ac.votes + current.votes
    }),
    { seat: 0, votes: 0 }
  );

  return (
    <div className="block block__pactometro">
      <div className="blockContent">
        <div className="pactometro__grafic">
          <div id="barra" className="pactos-barra">
            <div className="mayoria-pactometro">
              <p>55</p>
            </div>
            {selectedData.map(element => (
              <div
                key={element.name}
                className="partido"
                title={element.name}
                style={{
                  width: `${(100 / tot) * element.value}%`,
                  backgroundColor: element.color
                }}
              >
                {element.seat}
              </div>
            ))}
          </div>
        </div>
        <div className="pactometro_cardsWrapper">
          <ul className="pactometro_cards">
            {seatData &&
              seatData.map((dat, index) => {
                const checked = selectedsId.some(select => select === dat.id);
                return (
                  <li
                    key={dat.id}
                    className={`pactometro_card ${
                      checked ? '' : 'pactometro_card__disabled'
                    } `}
                    role="presentation"
                    onClick={() => onchange(dat.id)}
                  >
                    <div
                      className="pactometro_card_label"
                      style={{ backgroundColor: colors[index] }}
                    >
                      <img
                        className="party_logo"
                        src={logos[dat.name]}
                        alt={`Logo de ${dat.name}`}
                        title={dat.name}
                      />
                    </div>
                    <span className="pactometro_card_data">{dat.value}</span>
                  </li>
                );
              })}
          </ul>
          <div className="pactometro_total_wrapper">
            <div className="pactometro_total">
              <span className="pactometro_total_label">TOTAL ESCAÑOS</span>
              <span className="pactometro_total_value">{seat}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PactometroCards.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  // eslint-disable-next-line
  seatData: PropTypes.array.isRequired
};
export default PactometroCards;
